import rhinoBlue from 'rhino/src/core/blue/blue.module';
import rhinoClient from 'rhino/src/core/client/client.module';

import * as registryService from './registry.provider';

export default angular.module('rhino.core.registry', [
  rhinoBlue,
  rhinoClient,
])
  .provider(registryService.name, registryService.default)
  .name;



// WEBPACK FOOTER //
// ../~/@printos/rhino/src/core/registry/registry.module.js